import { api } from './client';

export interface HsnGstBand {
  id?: number;
  minPrice: number;
  maxPrice: number | null; // null = ∞
  gstPct: number;
}
export interface HsnGstEntry {
  hsnCode: string;
  description: string;
  bands: HsnGstBand[];
}

export async function listHsnGst(): Promise<HsnGstEntry[]> {
  const r = await api.get<HsnGstEntry[]>('/hsn-gst');
  return r.data;
}

/** Bands keyed by HSN — readable by sales users (Enquiry / Place Order). */
export async function listHsnGstBands(): Promise<import('@/lib/gstSplit').GstBandsByHsn> {
  const r = await api.get<import('@/lib/gstSplit').GstBandsByHsn>('/hsn-gst/bands');
  return r.data;
}

export async function setHsnGstBands(
  hsnCode: string,
  bands: { minPrice: number; maxPrice: number | null; gstPct: number }[],
): Promise<{ hsnCode: string; bands: number }> {
  const r = await api.put(`/hsn-gst/${encodeURIComponent(hsnCode)}`, { bands });
  return r.data;
}

export async function deleteHsnGst(hsnCode: string): Promise<{ hsnCode: string; removed: number }> {
  const r = await api.delete(`/hsn-gst/${encodeURIComponent(hsnCode)}`);
  return r.data;
}
